import { CheckOutlined } from '@ant-design/icons'
import { Button, Image, Tag, Tooltip } from 'antd'
import React, { useState } from 'react'
import { normalizeUrlString } from 'src/helpers/constants'
import { showMessageSuccess } from 'src/helpers/functions'
import { useStore } from 'src/hooks'

/**
 * O "Goi y" trong bang quan ly viec: hien goi y link dau tien cua viec
 * (`firstSuggestion` server tra kem trong danh sach) va nut "Gan URL" de them
 * link folder vao cot url cua viec ngay, khong can mo popup chi tiet.
 * Muon xem du 5 goi y / bo qua / tim lai thi vao popup chi tiet viec.
 */

const SUGGESTION_STATUS = {
   PENDING: 0,
   APPLIED: 1,
   REJECTED: 2
}

const getSuggestionLink = (record: any) => record?.folderUrl || record?.driveUrl || ''

type JobSuggestionCellProps = {
   job: any
}

const JobSuggestionCell: React.FC<JobSuggestionCellProps> = ({ job }) => {
   const JobsStore = useStore('JobsStore')
   const JobDetailStore = useStore('JobDetailStore')
   const [isApplying, setIsApplying] = useState(false)
   const suggestion = job?.firstSuggestion
   const link = getSuggestionLink(suggestion)

   if (!suggestion || !link) return <span style={{ color: '#b0b0b0' }}>{'—'}</span>

   const currentUrls = normalizeUrlString(job?.url).split(', ').filter(Boolean)
   const isApplied = suggestion.status === SUGGESTION_STATUS.APPLIED || currentUrls.includes(link)
   const isRejected = suggestion.status === SUGGESTION_STATUS.REJECTED

   const handleApply = async (event: React.MouseEvent) => {
      event.stopPropagation()
      setIsApplying(true)
      try {
         const data = await JobDetailStore.applySuggestion(suggestion.id)
         if (!data?.job) return
         // Va lai dong trong bang: url moi + trang thai goi y vua gan
         const nextSuggestion = (data.suggestions || []).find((item: any) => item.id === suggestion.id)
         JobsStore.action_patchJobRow(job.id, {
            url: data.job.url,
            firstSuggestion: nextSuggestion || { ...suggestion, status: SUGGESTION_STATUS.APPLIED }
         })
         showMessageSuccess('Đã gắn URL')
      } finally {
         setIsApplying(false)
      }
   }

   return (
      // Gioi han trong be rong o, khong tran sang cot ben canh
      <div style={{ display: 'flex', flexDirection: 'column', gap: 4, minWidth: 0, overflow: 'hidden' }}>
         {suggestion.thumbnailUrl && (
            <Image
               src={suggestion.thumbnailUrl}
               alt={suggestion.fileName}
               width={96}
               height={64}
               // Bo chu "Preview" de khong de len chu ben duoi, van bam de xem anh to
               preview={{ mask: null }}
               style={{ objectFit: 'contain', background: '#f5f5f5', borderRadius: 4 }}
               referrerPolicy="no-referrer"
            />
         )}
         <Tooltip title={link}>
            <a
               href={link}
               target="_blank"
               rel="noopener noreferrer external"
               className="txtMax2Line"
               style={{ wordBreak: 'break-all', fontSize: 12, lineHeight: '18px' }}
               onClick={(event) => event.stopPropagation()}
            >
               {suggestion.folderName || suggestion.fileName || link}
            </a>
         </Tooltip>
         {isApplied ? (
            <Tag color="green" icon={<CheckOutlined />} style={{ width: 'fit-content' }}>
               {'Đã gắn'}
            </Tag>
         ) : isRejected ? (
            <Tag style={{ width: 'fit-content' }}>{'Bỏ qua'}</Tag>
         ) : (
            <Button size="small" type="primary" loading={isApplying} onClick={handleApply} style={{ width: 'fit-content' }}>
               {'Gắn URL'}
            </Button>
         )}
      </div>
   )
}

export default JobSuggestionCell
